const HIDDEN_PROVIDER_NAMES_BY_CATEGORY = {
  SLOTS: ["918Kiss", "Ninja slot"],
  CARD: ["Kingpoker"],
  FISHING: ["918Kiss", "Ninja slot"],
};

const normalizeProviderName = (value) =>
  String(value || "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();

export const getHiddenProviderNamesByCategory = (categoryCode) => {
  const normalizedCategoryCode = String(categoryCode || "").toUpperCase();
  return HIDDEN_PROVIDER_NAMES_BY_CATEGORY[normalizedCategoryCode] || [];
};

export const filterVisibleProvidersByCategory = (providers, categoryCode) => {
  const hiddenProviderNames = getHiddenProviderNamesByCategory(categoryCode);

  if (!Array.isArray(providers) || hiddenProviderNames.length === 0) {
    return Array.isArray(providers) ? providers : [];
  }

  const hiddenProviderNameSet = new Set(
    hiddenProviderNames.map(normalizeProviderName),
  );

  return providers.filter((provider) => {
    const providerName = normalizeProviderName(
      provider?.productName || provider?.name,
    );

    return !hiddenProviderNameSet.has(providerName);
  });
};
